export class AccelerateApplication {
  applicationId
  stage
  registrationLink

  constructor(accelerateApplication = {}) {
    this.applicationId = accelerateApplication.applicationId ? String(accelerateApplication.applicationId) : ''
    this.stage = accelerateApplication.stage ? Number(accelerateApplication.stage) : 0
    this.registrationLink = accelerateApplication.registrationLink ? String(accelerateApplication.registrationLink) : ''
  }
}